import { useContext } from 'react';
// Contexts
import { OpenIdContext } from '../contexts/OpenIdContext';

// ..........................................................

export default () => useContext(OpenIdContext);
